import { render, staticRenderFns } from "./imeiBindHistory.vue?vue&type=template&id=81e93394&"
import script from "./imeiBindHistory.vue?vue&type=script&lang=js&"
export * from "./imeiBindHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports